import React, { useState } from "react";

const MastersProgrammeNav = () => {
  const [activeLink, setActiveLink] = useState(null);

  const scrollToSection = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    setActiveLink(id);
  };

  const navItems = [
    { name: "Overview", id: "overview" },
    { name: "Learning Outcomes", id: "learning-outcomes" },
    { name: "Modules", id: "modules" },
    { name: "Entry Requirements", id: "entry-requirements" },
    { name: "Programme Fees", id: "programme-fees" },
    // { name: "How To Pay", id: "how-to-pay" },
    // { name: "IT Requirements", id: "it-requirements" },
    { name: "Career Opportunities", id: "career-opportunities" },
  ];

  return (
    <div className="sticky z-10 top-[68px] lg:top-28">
      <div className="shadow block lg:hidden bg-blue-50 border-y-2 border-gray-400">
        <ul className="flex space-x-2 px-4 py-3 overflow-x-auto whitespace-nowrap [&::-webkit-scrollbar]:hidden -webkit-overflow-scrolling-touch">
          {navItems.map((item) => (
            <li key={item.id}>
              <a
                href={`#${item.id}`}
                onClick={(e) => scrollToSection(e, item.id)}
                className={`inline-block py-2 px-3 rounded-md text-sm font-medium hover:bg-blue-100 transition-colors ${
                  activeLink === item.id ? "border-b-2 border-b-sdorange text-sdorange" : "text-gray-700"
                }`}
              >
                {item.name}
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div className="hidden lg:block border-y-2 border-gray-300 bg-blue-50">
        <ul className="flex justify-center space-x-4 py-3">
          {navItems.map((item) => (
            <li key={item.id}>
              <a
                href={`#${item.id}`}
                onClick={(e) => scrollToSection(e, item.id)}
                className={`py-3 px-2 hover:border-b-2 hover:border-b-sdorange transition-colors ${
                  activeLink === item.id ? "border-b-2 border-b-sdorange text-sdorange font-medium" : ""
                }`}
              >
                {item.name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default MastersProgrammeNav;
